import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Cross from './icons/Cross';
import { color } from '../templates/Ui';
const StyledButton = styled.button `
    position: absolute;
    top: 40px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e4e4e4;
    border: none;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    transition: all 150ms ease-in-out;
    cursor: pointer;

    &:hover {
        .icon--cross {
            fill: ${color.error.base};
        }
    }
`;
const StyledCross = styled(Cross) `
    fill: #5d5d5d;
    width: 8px;
    height: 8px;
    transition: all 150ms ease-in-out;
`;
const InputClearButton = ({ onClick, ...restProps }) => (_jsx(StyledButton, { type: 'button', onClick: onClick, ...restProps, children: _jsx(StyledCross, { className: "icon--cross" }) }));
export default InputClearButton;
